import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { HolidayModel } from "./models/holiday-model";
import { WorkdayOrganizerDataService } from "./services/workday-organizer-data.service";
import { WorkingDaysComponent } from "./components/working-days/working-days.component";
import { HolidaysDaysoffComponent } from "./components/holidays-daysoff/holidays-daysoff.component";
import { setTime } from "@syncfusion/ej2-angular-schedule";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { CerrixPageFooterComponent } from "@app/shared/cerrix-page-footer/cerrix-page-footer.component";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";

@Component({
    selector: "workday-organizer",
    templateUrl: "./workday-organizer.component.html",
    styleUrl: "./workday-organizer.component.scss",
    imports: [
        MenuSystemDirective,
        WorkingDaysComponent,
        HolidaysDaysoffComponent,
        CerrixPageFooterComponent,
        CerrixButtonComponent,
    ]
})
export class WorkdayOrganizerComponent implements OnInit {
    private _workDaysDS = inject(WorkdayOrganizerDataService);

    tab: TabModel;

    public workingDays: string[] = [];
    public holidaysDaysOff: HolidayModel[] = [];

    public workingDaysDirty: boolean = false;
    public holidaysDirty: boolean = false;
    public savingOrganizer: boolean = false;
    public organizerSaved: boolean = false;

    async ngOnInit(): Promise<void> {
        this.workingDays = await this._workDaysDS.GetWorkDays();
        this.holidaysDaysOff = await this._workDaysDS.GetHolidays();
    }

    async saveOrganizer(): Promise<void> {
        this.savingOrganizer = true;
        if (this.workingDaysDirty) {
            await this._workDaysDS.StoreWorkDays(this.workingDays);
            this.workingDaysDirty = false;
        }
        if (this.holidaysDirty) {
            await this._workDaysDS.StoreHolidays(this.holidaysDaysOff);
            this.holidaysDirty = false;
        }
        this.savingOrganizer = false;
        this.organizerSaved = true;
        setTimeout(() => {
            this.organizerSaved = false;
        }, 2000);
    }
}
